import CustomCard from "./custom-card.container";
export default CustomCard;
